import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setEvaluated } from "ajv/dist/compile/util";
import { AUTH_TOKEN, CURRENT_USER } from "constants/AuthConstant";
import AuthService from "services/AuthService";
import RoleService from "services/rolesService";
import { formatValidationErrors } from "utils/ArrayUtils";

export const initialState = {
  list: [],
  fetching: false,
  creating: false,
  updating: false,
  deleting: false,
  errorMessages: [],
  showMessage: false,
  showEditForm: false,
  showNewForm: false,
};

export const fetchRoles = createAsyncThunk(
  "/fetchRoles",
  async (data, { rejectWithValue }) => {
    try {
      const response = await RoleService.fetch();
      var code = response.code;
      return {
        code: code,
        roles: response,
      };
    } catch (err) {
      let code = err.response?.data.code;
      let response = err.response;
      return rejectWithValue({
        code: code,
        errorMessages: response?.data?.message || "Error",
      });
    }
  }
);

export const createRole = createAsyncThunk(
  "/creatRole",
  async (data, { rejectWithValue }) => {
    try {
      const response = await RoleService.create(data);
      const code = response.code;
      return {
        code: code,
        roles: response.original,
      };
    } catch (err) {
      return rejectWithValue(
        { code: err.response.status, error: err.response?.data.errors } || {
          error: "Error creating a role",
        }
      );
    }
  }
);

export const updateRole = createAsyncThunk(
  "/updateRole",
  async (data, { rejectWithValue }) => {
    try {
      const response = await RoleService.update(data);
      const code = response.code;
      return {
        code: code,
        roles: response.original,
      };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error");
    }
  }
);

export const deleteRole = createAsyncThunk(
  "/deleteRole",
  async (id, { rejectWithValue }) => {
    try {
      const response = await RoleService.delete(id);
      const code = response.code;
      return {
        code: code,
        roles: response.original,
      };
    } catch (err) {
      return rejectWithValue({ error: "Error deleting a role" });
    }
  }
);

export const roleSlice = createSlice({
  name: "roles",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.fetching = !state.fetching;
    },
    toggleRoleEditForm: (state) => {
      state.showEditForm = !state.showEditForm;
    },
    toggleRoleNewForm: (state) => {
      state.showNewForm = !state.showNewForm;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRoles.pending, (state) => {
        state.fetching = true;
      })
      .addCase(fetchRoles.fulfilled, (state, action) => {
        state.fetching = false;
        state.list = action.payload.roles;
      })
      .addCase(fetchRoles.rejected, (state, action) => {
        state.fetching = false;
      })
      .addCase(createRole.pending, (state) => {
        state.creating = true;
      })
      .addCase(createRole.fulfilled, (state, action) => {
        state.creating = false;
        state.list = action.payload.roles;
        state.showNewForm = !state.showNewForm;
      })
      .addCase(createRole.rejected, (state, action) => {
        if (action.payload.code == 422) {
          state.errorMessages = formatValidationErrors(action.payload.error);
        } else {
          // state.errorMessages = action.payload.error;
        }
        state.creating = false;
      })
      .addCase(updateRole.pending, (state, action) => {
        state.updating = true;
      })
      .addCase(updateRole.fulfilled, (state, action) => {
        state.updating = false;
        state.list = action.payload.roles;
        state.showEditForm = !state.showEditForm;
      })
      .addCase(updateRole.rejected, (state, action) => {
        state.errorMessages = action.payload;
        state.updating = false;
      })
      .addCase(deleteRole.pending, (state, action) => {
        state.deleting = true;
      })
      .addCase(deleteRole.fulfilled, (state, action) => {
        state.deleting = false;
        state.list = action.payload.roles;
      })
      .addCase(deleteRole.rejected, (state, action) => {
        state.deleting = false;
      });
  },
});

export const { showLoading, toggleRoleEditForm, toggleRoleNewForm } =
  roleSlice.actions;

export default roleSlice.reducer;
